import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const warehouseSlasReturnsCenterStatsSchema = z.object({
  id: returnsCenterIdFormat.schema,
  name: z.string(),
  // Returns KPIs
  avgProcessingTimeDays: z.number().nullable(),
  processingTimeSampleCount: z.number(),
  totalReturnsProcessedCount: z.number(),
  processedWithin3DaysCount: z.number(),
  // Fulfillment KPIs
  avgFulfillmentTimeDays: z.number().nullable(),
  fulfillmentTimeSampleCount: z.number(),
  totalFulfillmentsCount: z.number(),
  ordersInRangeCount: z.number(),
  noonCutoffMetCount: z.number(),
});

export type WarehouseSlasReturnsCenterStats = z.infer<
  typeof warehouseSlasReturnsCenterStatsSchema
>;

export const getWarehouseSlasDashboard = {
  name: "getWarehouseSlasDashboard" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({
    returnsCenters: z.array(warehouseSlasReturnsCenterStatsSchema),
  }),
};
